import http from './BaseUrl';

// Keep production API configuration unchanged while using the current Gallery session.
http.interceptors.request.use((request) => {
  if ((request.url || '').startsWith('social-gallery-v2/')) {
    const token = localStorage.getItem('token_verify');
    request.headers = request.headers || {};
    if (token) request.headers.Authorization = `Bearer ${token}`;
    else delete request.headers.Authorization;
  }
  return request;
});
